/**
 * Field options configuration for disclosure document header
 */

export const DISCLOSURE_TYPE_OPTIONS = [
    {value: "NDP-1", label: "National Disclosure Policy-1 (Public Release)"},
    {value: "NDP-2", label: "National Disclosure Policy-2 (Government Use Only)"},
    {value: "NDP-3", label: "National Disclosure Policy-3 (Restricted Government)"},
    {value: "NDP-4", label: "National Disclosure Policy-4 (Allied Release Approved)"},
    {value: "NDP-5", label: "National Disclosure Policy-5 (Foreign Disclosure Case-by-Case)"},

    {value: "REL", label: "Releasable"},
    {value: "REL-ALLIES", label: "Releasable to Specified Allies"},
    {value: "NOFORN", label: "Not Releasable to Foreign Nationals (NOFORN)"},

    {value: "FOUO", label: "For Official Use Only (FOUO)"},
    {value: "CUI", label: "Controlled Unclassified Information (CUI)"},

    {value: "CONF", label: "Confidential"},
    {value: "SECRET", label: "Secret"},
    {value: "TS", label: "Top Secret"},

    {value: "TS-SCI", label: "Top Secret / Sensitive Compartmented Information"},
    {value: "ORCON", label: "Originator Controlled (ORCON)"},
    {value: "IMCON", label: "Intelligence Control (IMCON)"}
];

export const INTEL_SHARING_PARTNERS = [
    'Australia',
    'Canada',
    'New Zealand',
    'United Kingdom'
];

export const TREATY_ALLIES = [
    'Albania', 'Belgium', 'Bulgaria', 'Croatia', 'Czechia', 'Denmark', 'Estonia',
    'Finland', 'France', 'Germany', 'Greece', 'Hungary', 'Iceland', 'Italy',
    'Japan', 'Latvia', 'Lithuania', 'Luxembourg', 'Montenegro', 'Netherlands',
    'North Macedonia', 'Norway', 'Philippines', 'Poland', 'Portugal', 'Romania',
    'Slovakia', 'Slovenia', 'South Korea', 'Spain', 'Sweden', 'Thailand', 'Turkey'
];

export const CLOSE_SECURITY_PARTNERS = [
    'Argentina', 'Bahrain', 'Brazil', 'Colombia', 'Egypt', 'Israel', 'Jordan',
    'Kenya', 'Kuwait', 'Morocco', 'Pakistan', 'Qatar', 'Saudi Arabia', 'Tunisia',
    'Taiwan'
];

export const LIMITED_COOPERATION_PARTNERS = [
    'Afghanistan', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Armenia',
    'Austria', 'Azerbaijan', 'Bahamas', 'Bangladesh', 'Barbados', 'Belarus', 'Belize',
    'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brunei',
    'Burkina Faso', 'Burundi', 'Cabo Verde', 'Cambodia', 'Cameroon', 'Central African Republic',
    'Chad', 'Chile', 'Comoros', 'Congo', 'Costa Rica', 'Côte d\'Ivoire', 'Cuba', 'Cyprus',
    'Democratic Republic of the Congo', 'Djibouti', 'Dominica', 'Dominican Republic',
    'Ecuador', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Eswatini', 'Ethiopia',
    'Fiji', 'Gabon', 'The Gambia', 'Georgia', 'Ghana', 'Guatemala', 'Guinea', 'Guinea-Bissau',
    'Guyana', 'Haiti', 'Honduras', 'India', 'Indonesia', 'Iraq', 'Ireland', 'Jamaica',
    'Kazakhstan', 'Kiribati', 'Kyrgyzstan', 'Laos', 'Lebanon', 'Lesotho', 'Liberia',
    'Libya', 'Liechtenstein', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali',
    'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia (Federated States of)',
    'Moldova', 'Monaco', 'Mongolia', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal',
    'Nicaragua', 'Niger', 'Nigeria', 'Oman', 'Palau', 'Panama', 'Papua New Guinea',
    'Paraguay', 'Peru', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines',
    'Samoa', 'San Marino', 'São Tomé and Príncipe', 'Senegal', 'Serbia', 'Seychelles',
    'Sierra Leone', 'Singapore', 'Solomon Islands', 'Somalia', 'South Africa', 'South Sudan',
    'Sri Lanka', 'Sudan', 'Suriname', 'Switzerland', 'Syria', 'Tajikistan', 'Tanzania',
    'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Turkmenistan', 'Tuvalu',
    'Uganda', 'Ukraine', 'United Arab Emirates', 'Uruguay', 'Uzbekistan', 'Vanuatu',
    'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'
];

export const ADVERSARIES = [
    'China (PRC)',
    'Russia',
    'Iran',
    'North Korea (DPRK)'
];

// Organized country groups with categories
export const COUNTRY_CATEGORIES = [
    {
        category: 'Intel-sharing partners',
        countries: INTEL_SHARING_PARTNERS
    },
    {
        category: 'Treaty allies / coalition frameworks',
        countries: TREATY_ALLIES
    },
    {
        category: 'Close security partners (non-treaty / situational)',
        countries: CLOSE_SECURITY_PARTNERS
    },
    {
        category: 'Limited cooperation partners',
        countries: LIMITED_COOPERATION_PARTNERS
    },
    {
        category: 'Adversaries',
        countries: ADVERSARIES
    }
];

// Flatten all countries for selection
export const ALL_COUNTRIES = [
    ...INTEL_SHARING_PARTNERS,
    ...TREATY_ALLIES,
    ...CLOSE_SECURITY_PARTNERS,
    ...LIMITED_COOPERATION_PARTNERS,
    ...ADVERSARIES
].sort();

export const PURPOSE_OPTIONS = [
    {value: 'coalition_support', label: 'Coalition support'},
    {value: 'warning', label: 'Warning'},
    {value: 'deconfliction', label: 'Deconfliction'},
    {value: 'partner_action', label: 'Partner action'}
];

export const POLICY_OPTIONS = [
    {
        value: 'default',
        label: 'Default policy',
        description: 'Remove collection specifics, unique access, timing/precision that signals capability and anything that obviously reveals sensitive collection posture. Remove any information about friendly countries and the recognized government of the country this is being released to, but leave information on domestic adversaries.'
    },
    {
        value: 'restrictive',
        label: 'Restrictive policy',
        description: 'Remove everything other than strategic/defensive info supporting [purpose name selected above], leave minimal sourcing cues.'
    }
];

export const DEFAULT_DISCLOSURE_HEADER_DATA = {
    disclosureType: DISCLOSURE_TYPE_OPTIONS[0],
    selectedCountries: '',
    purpose: PURPOSE_OPTIONS[0],
    additionalInstructions: '',
    applyPolicy: {value: 'default', label: 'Default policy'},
    displayOnly: false
};
